export default "__VITE_ASSET__b79d417a__"